<template src="../components/vue/template-search.html"></template>

<script>

import search from './vue/components/search.vue'

export default {
    components: {
        // 'filter-form': filterForm,
        'search': search
    }
};

</script>